//添加新设备保存列表
export const DEVICEMANAGEMENT_ADD_DEVICE_LIST='DEVICEMANAGEMENT/DEVICE/LIST/DEVICEMANAGEMENT_ADD_DEVICE_LIST';